import {HTMLProps, useEffect, useRef} from 'react';
import HomeHeaderRightV4 from './HomeHeaderRightV4';
import HomeMenuListV4 from './HomeMenuListV4';
import HomeSecondTabListV4 from './HomeSecondTabListV4';
import ICON_GIFT_LIGHT from '../../../../public/static/v4/home-header/icon-gift-light.svg';
import ICON_GIFT from '../../../../public/static/v4/home-header/icon-gift.svg';
import Header from '../../../common/component/Header';
import HeaderGradientV4 from '../../../common/component/HeaderGradientV4';
import RedDot from '../../../common/component/RedDot';
import {Page} from '../../../common/constant/page';
import useTheme from '../../../common/hook/useTheme';
import {
  HEADER_HEIGHT_V4,
  MAIN_TAB_HEIGHT_V4,
  SUB_TAB_HEIGHT_V4,
} from '../../../common/scss/util/variable';
import {routeTo} from '../../../common/util/PageRouter';
import {GNB_STATE} from '../common';
import {sendHomeEvent} from '../tracking';
import {HomeTabPage, ISecondTabItem, ISecondTabs} from '../type';

interface IProps extends Omit<HTMLProps<HTMLDivElement>, 'ref'> {
  hasNewGift: boolean;
  hasNewMore: boolean;
  currentTabPage: HomeTabPage;
  secondTabs: ISecondTabs;
  onClickLogo: () => void;
  onClickHome: (tabPage: HomeTabPage) => void;
  onClickSecondTab: (tab: ISecondTabItem) => void;
}

export default function HomeHeaderV4({
  hasNewGift,
  hasNewMore,
  currentTabPage,
  secondTabs,
  onClickLogo,
  onClickHome,
  onClickSecondTab,
  className,
  ...rest
}: IProps) {
  const {isLightMode} = useTheme();
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    GNB_STATE.headerEl = ref.current;
  }, []);

  const secondTab = secondTabs[currentTabPage];

  return (
    <div
      ref={ref}
      className={cn(
        'translate-y-0 transition-transform duration-[250ms] z-navigationBar',
        'left-0 fixed top-0 w-full',
        className
      )}
      {...rest}
    >
      <HeaderGradientV4 style={MAIN_PAGE_GRADIENT_HEIGHT_STYLE_V4} />
      <Header
        leftElement={
          <>
            <img src={isLightMode ? ICON_GIFT_LIGHT : ICON_GIFT} alt="gift" />
            {hasNewGift && <RedDot className="right-0 top-0" />}
          </>
        }
        onClick={() => {
          sendHomeEvent({
            actionName: 'giftbox_icon',
            action: 'click',
            customProps: {event_layer: 'header'},
          });
          routeTo({page: Page.Gift});
        }}
        rightElement={<HomeHeaderRightV4 hasNewMore={hasNewMore} />}
        className="!relative !h-header-height"
      />
      <HomeMenuListV4
        currentTabPage={currentTabPage}
        onClick={onClickHome}
        className="relative z-navigationBarMinus1 px-18 sm:px-24"
      />
      <HomeSecondTabListV4
        key={currentTabPage}
        secondTabSelected={secondTab.selected}
        secondTabList={secondTab.tabList}
        onClickSecondTab={onClickSecondTab}
      />
    </div>
  );
}

export const MAIN_PAGE_GRADIENT_HEIGHT_V4 =
  HEADER_HEIGHT_V4 + MAIN_TAB_HEIGHT_V4 + SUB_TAB_HEIGHT_V4;

export const PADDING_TOP_STYLE_V4 = {
  paddingTop: MAIN_PAGE_GRADIENT_HEIGHT_V4,
};

const MAIN_PAGE_GRADIENT_HEIGHT_STYLE_V4 = {
  height: MAIN_PAGE_GRADIENT_HEIGHT_V4,
};
